// Filters shared by Find jobs and Platypus.
export const WORK_TYPES = ["Remote", "Hybrid", "On-site"];
export const EMPLOYMENT_TYPES = [
  "Full-time",
  "Internship",
  "Part-time",
  "Contract",
  "Temporary",
];
export const EXPERIENCE_LEVELS = ["Entry level", "Mid level", "Senior"];
export const LEVEL_HINTS = {
  "Entry level": "0–2 yrs, new grad",
  "Mid level": "2–5 yrs",
  Senior: "5+ yrs",
};
export const COMPANY_TYPES = ["Startups"];
export const COMPANY_TYPE_HELP = "a16z startups";
export const VISA_OPTIONS = ["sponsors", "f1"];
export const VISA_LABELS = {
  sponsors: "Sponsors visas (H-1B)",
  f1: "Open to F-1 (OPT/CPT)",
};
export const VISA_HELP =
  "Uses what the posting says, and otherwise whether the company has had H-1B petitions approved (USCIS data). Postings that rule out sponsorship or need US citizenship are left out.";
